// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"142":"9b11ee47","716":"4b06a9fd"}[chunkId] + ".js";
};